import { render, staticRenderFns } from "./EntregaListaItem.vue?vue&type=template&id=1d356a9b&"
import script from "./EntregaListaItem.vue?vue&type=script&lang=js&"
export * from "./EntregaListaItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports